import { type RefObject, useEffect } from 'react';

// Two A legs + two B legs of the transitions.dev error shake.
const readShakeMs = () => {
  const styles = getComputedStyle(document.documentElement);
  const read = (name: string, fallback: number) => {
    const value = Number.parseFloat(styles.getPropertyValue(name));
    return Number.isFinite(value) ? value : fallback;
  };

  return read('--shake-dur-a', 80) * 2 + read('--shake-dur-b', 60) * 2;
};

/**
 * Replays the `.t-input` shake on `element` whenever `trigger` changes to a truthy value — a new
 * error message, or a new submit that failed again.
 */
// eslint-disable-next-line @typescript-eslint/ban-types -- React 19's useRef(null) yields RefObject<T | null>
const useShake = (elementRef: RefObject<HTMLElement | null>, trigger: unknown) => {
  useEffect(() => {
    const element = elementRef.current;

    if (!trigger || !element) {
      return;
    }

    element.classList.remove('is-shaking');
    // Forces a reflow so re-adding the class restarts the keyframes.
    void element.offsetWidth;
    element.classList.add('is-shaking');

    const timer = setTimeout(() => {
      element.classList.remove('is-shaking');
    }, readShakeMs() + 20);

    return () => {
      clearTimeout(timer);
    };
  }, [elementRef, trigger]);
};

export default useShake;
